import { useEffect, useRef }  from "react";
import { useLocation } from "react-router-dom";
import { addSentryBreadcrumb } from "@/lib/sentry";

/**
 * Invisible component that records a Sentry breadcrumb on every
 * React Router navigation. Render once inside <BrowserRouter>.
 */
export default function SentryRouteBreadcrumb(): null {
  const location = useLocation();
  const previous = useRef<string>(location.pathname + location.search);

  useEffect(() => {
    const to = location.pathname + location.search;
    const from = previous.current;
    if (to !== from) {
      addSentryBreadcrumb({
        category: "navigation",
        type: "navigation",
        message: `Route change: ${from} → ${to}`,
        data: { from, to },
        level: "info",
      });
      previous.current = to;
    }
  }, [location.pathname, location.search]);

  return null;
}
